import React, { useContext } from "react";
import { OutsourceOrderSortTypes } from "../../../configs/sortTypes";
import { OutsourceOrderFilterType } from "../../../configs/filterTypes";
import ListView from "../../../shared/components/ListView";
import { Search, TableColumns } from "../../../configs/outsourceOrder";
import { OutsourceOrderRow } from "./OutsourceOrderTable";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";

const Content = () => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const getTableColumns = () => {
        switch (role) {
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
                return TableColumns.filter((item) => item.text !== "Giá");
            case ROLE.LOGISTIC_STAFF:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
            case ROLE.LOGISTIC_MANAGER:
                return TableColumns;
            default:
                return [];
        }
    };

    return (
        <ListView
            url="/materials/outsource-orders/"
            sortTypes={OutsourceOrderSortTypes}
            filterTypes={OutsourceOrderFilterType}
            rowElement={OutsourceOrderRow}
            tableColumns={getTableColumns()}
            textString={Search.searchText}
        />
    );
};

export default Content;
